var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPride(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6d2380",
    d: "M0 0h1200v762H0V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c58a4",
    d: "M0 0h1200v635H0V0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#78b82a",
    d: "M0 0h1200v508H0V0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#efe524",
    d: "M0 0h1200v381H0V0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f28917",
    d: "M0 0h1200v254H0V0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e22016",
    d: "M0 0h1200v127H0V0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M315 0H0v762h315l353-381L315 0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#945516",
    d: "M241 0H0v762h241l353-381L241 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#7bcce5",
    d: "M168 0H0v762h168l353-381L168 0z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4aec8",
    d: "M95 0H0v762h95l353-381L95 0z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0v762h22l352-381L22 0H0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd817",
    d: "m0 706 301-325L0 55v651z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 381,
    r: 80,
    fill: "none",
    stroke: "#66338b",
    strokeWidth: 19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPride);
export default __webpack_public_path__ + "static/media/pride.fa083a464927c2a0723a285ebda0c209.svg";
export { ForwardRef as ReactComponent };